const timelineElements = [
    {
        id:3,
        title:'Software Engineer II',
        location: 'Appian | Mclean, Virginia',
        description: 'Building new features and maintaining operations for my team\'s micro-service. Winning team of 2023\'s company wide hackation: "Bring your own AI model".',
        date: '2022-Present',
        image: 'appian',
        icon: 'work',
        tech: ['Java', 'Python', 'AWS', 'Kubernetes', 'SAIL', 'Docker'],
    },
    {
        id:2,
        title:'Graduated from the University of Virginia',
        location: 'UVA | Charlottesville, Virginia',
        description: 'Completed my Bachelors of Science degree in Computer Science with a 3.7 GPA',
        date: '2018-2022',
        image: 'uva',
        icon: 'school',
        tech: ['Java', 'Python', 'AWS', 'PHP', 'SQL', 'C++', 'Machine Learning', 'AI'],
    },
    {
        id:1,
        title:'Software Engineering Intern',
        location: 'Noblis | Remote / Reston, Virginia',
        description: 'Developed a Subgraph Matching tool for Re-Identification within graph analytics with an 8.25% Equal Error Rate using Python in an Agile environment in a two-week cycle. Researched Graph packages to add in the Vue.js applications for front end',
        date: '2021',
        image: 'noblis',
        icon: 'work',
        tech: ['Python', 'Machine Learning', 'Graph Analytics'],
    },
    {
        id:0,
        title:'Data Science Intern',
        location: 'Perspecta | Remote / Chantilly, Virginia',
        description: 'Developed a functional Time Series Classification pipeline deployed with AWS architecture that classifies live data streams. The response from the pipeline comes back in 30 seconds.',
        date: '2020',
        image: 'perspecta',
        icon: 'work',
        tech: ['Python', 'Kafka', 'AWS', 'Time-Series Classification', 'Machine Learning'],
    }
]

export default timelineElements